import { RouteLocationResolvedGeneric, type RouteLocationNormalized } from 'vue-router';

import { useFeaturesStore } from '@/store/modules/features';
import { storeToRefs } from 'pinia';

function useFeatureToggleStore() {
  const featureStore = useFeaturesStore();
  const { enabledFeatures } = storeToRefs(featureStore);

  return { featureStore, enabledFeatures };
}

export function getFeaturesFromRoute(
  route: RouteLocationNormalized | RouteLocationResolvedGeneric,
): string[] {
  const features = (route.query?.feature || '') as string;

  return features
    .split(',')
    .map((feature) => feature.trim())
    .filter((feature) => feature);
}

export function isFeatureEnabled(
  key: string,
  route: RouteLocationNormalized | RouteLocationResolvedGeneric,
): boolean {
  const { featureStore, enabledFeatures } = useFeatureToggleStore();

  const persistedFeatures = enabledFeatures.value;

  const featuresFromRoute = getFeaturesFromRoute(route);
  const allFeaturesAlreadyPersisted = featuresFromRoute.every((val) =>
    persistedFeatures.includes(val),
  );

  if (!allFeaturesAlreadyPersisted) {
    let features = [...persistedFeatures, ...featuresFromRoute];
    features = Array.from(new Set(features)); // remove duplicates
    featureStore.setEnabledFeatures(features);
    return features.includes(key);
  }

  return persistedFeatures.includes(key);
}

export function getApiVersion(
  api: string,
  route: RouteLocationNormalized | RouteLocationResolvedGeneric,
): number | undefined {
  const { enabledFeatures } = useFeatureToggleStore();

  const features = [...enabledFeatures.value, ...getFeaturesFromRoute(route)];

  const feature = features.find((f) => f.startsWith(api + '_'));

  return feature ? parseInt(feature.substring(api.length + 1), 10) : undefined;
}
